<template>
  <div
    class="panel panel-default"
    id="surveyViewPanel"
    v-if="globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Read')"
  >
    <div class="panel-body" id="surveyViewForm">
      <div
        class="col-lg-3 col-xs-12 col-lg-push-9"
        id="meta-information-container"
      >
        <div class="form-group" style="padding-bottom: 10px" v-if="surveyData">
          <label for="selectSurveyLanguage" class="col-md-4 control-label">{{
            lang.SV0051
          }}</label>
          <div class="col-md-8">
            <select2
              class="form-control"
              id="selectSurveyLanguage"
              v-model="surveyLocaleCode"
              @change="changeSurveyLanguage()"
            >
              <option
                v-for="language in surveyData.Languages"
                :key="language.LocaleCode"
                :value="language.LocaleCode"
              >
                {{ language.LocaleName }}
              </option>
            </select2>
          </div>
        </div>
        <div
          v-if="surveyData && surveyData.SurveyLogoId"
          class="survey-logo-container"
        >
          <img :src="'/api/Download/' + surveyData.SurveyLogoId" />
        </div>
        <span id="metaInformationHeader">{{ lang.SV0000 }}</span>
        <div class="information">
          <b>
            {{ lang.SV0013 }}
            :
          </b>
          {{ metaInformation.SurveyInstanceId }}
          <i
            id="showCheckHistoryInfoIcon"
            class="material-icons md-24"
            @click="showCheckHistory()"
            >history</i
          >
          <b-tooltip
            ref="tooltip"
            target="showCheckHistoryInfoIcon"
            :delay="globals.tooltipDelay"
            >{{ lang.SV0061 }}</b-tooltip
          >
          <br />
          <b>{{ lang.SV0014 }}:</b>
          {{ metaInformation.SurveyId }}
          <template v-if="metaInformation.ShortSurveyCode">
            <br />
            <b>{{ lang.SV0015 }}:</b>
            {{ metaInformation.ShortSurveyCode }}
          </template>
          <br />
          <b>{{ lang.SV0016 }}:</b>
          {{ metaInformation.LocationStoreId }}
          <br />
          <b>{{ lang.SV0017 }}:</b>
          {{ metaInformation.LocationName }}
          <br />
          <b>{{ lang.SV0018 }}:</b>
          {{ metaInformation.LocationAddress }}
          <br />
          <b>{{ lang.SV0019 }}:</b>
          {{ metaInformation.LocationCountry }}
          <br />
          <b>{{ lang.SV0020 }}:</b>
          {{ metaInformation.ScenarioName }}
          <br />
          <b>{{ lang.SV0021 }}:</b>
          {{ metaInformation.WaveName }}
          <i
            id="carModelDistributionInfoIcon"
            v-if="metaInformation.CarModelDistribution"
            class="material-icons md-18"
            style="vertical-align: middle; cursor: pointer"
            >drive_eta</i
          >
          <b-tooltip
            ref="tooltip"
            v-if="
              metaInformation.CarModelDistribution ||
              metaInformation.CompetitorCarModelDistribution
            "
            target="carModelDistributionInfoIcon"
            :delay="globals.tooltipDelay"
          >
            <template v-if="metaInformation.CarModelDistribution">
              <b>{{ lang.SV0060 }}:</b>
              <br />
              <span
                v-for="model in metaInformation.CarModelDistribution"
                :key="model.CarModelGuid"
              >
                {{ model.CarModelName }} - {{ model.Distribution * 100 }}%
                <br />
              </span>
            </template>
            <template
              v-if="
                metaInformation.CarModelDistribution &&
                metaInformation.CompetitorCarModelDistribution
              "
            >
              <br />
            </template>
            <template v-if="metaInformation.CompetitorCarModelDistribution">
              <b>{{ lang.SV0062 }}:</b>
              <br />
              <span
                v-for="model in metaInformation.CompetitorCarModelDistribution"
                :key="model.CompetitorCarModelGuid"
              >
                {{ model.CompetitorCarModel }} - {{ model.Distribution * 100 }}%
                <br />
              </span>
            </template>
          </b-tooltip>
          <template v-if="metaInformation.WaveInfo">
            <br />
            <b>{{ lang.SV0059 }}:</b>
            {{ metaInformation.WaveInfo }}
          </template>
          <template v-if="metaInformation.SurveyInstanceInfo">
            <br />
            <b>{{ lang.SV0057 }}:</b>
            {{ metaInformation.SurveyInstanceInfo }}
          </template>
          <template v-if="globals.currentUserRole < 3">
            <br />
            <span id="surveyViewMetaInfoScoreSpan">
              <b>
                {{ lang.SV0029 }}
                <i
                  class="material-icons md-18"
                  style="vertical-align: middle; cursor: pointer"
                  >help_outline</i
                >
                :
              </b>
              {{ metaInformation.Score }}
            </span>
          </template>
          <template v-if="metaInformation.ApprovedShopper">
            <br />
            <b>{{ lang.SV0063 }}:</b>
            {{ metaInformation.ApprovedShopper.DisplayName }}
            <div id="approvedShopperDetailsContainer">
              {{ lang.SV0064 }} ({{ lang.SV0065 }}):
              {{ metaInformation.ApprovedShopper.ShopperAge }} ({{
                metaInformation.ApprovedShopper.Gender
              }})
              <br />
              {{ lang.SV0066 }}:
              {{ metaInformation.ApprovedShopper.ShopperCar }}
              <br />
              {{ lang.SV0067 }}:
              {{ metaInformation.ApprovedShopper.CarSegmentName }}
              <br />
              {{ lang.SV0068 }}:
              {{ metaInformation.ApprovedShopper.CarModelName }}
            </div>
          </template>
          <b-tooltip
            v-if="globals.currentUserRole < 3"
            ref="tooltip"
            target="surveyViewMetaInfoScoreSpan"
            :delay="globals.tooltipDelay"
            >{{ lang.SV0030 }}</b-tooltip
          >
          <br />
        </div>
        <div class="form-group">
          <label for="inputDateSurveyView" class="col-md-4 control-label"
            >{{ lang.SV0001 }}*</label
          >
          <div
            class="col-md-8"
            @click="globals.toggleFlatpickr('inputDateSurveyView')"
          >
            <input
              type="text"
              class="form-control"
              id="inputDateSurveyView"
              @change="validateInput('inputDateSurveyView')"
              :disabled="inputMetaInformationDisabled"
            />
            <span
              v-show="inputHasError('inputDateSurveyView')"
              class="help-block error text-danger"
              >{{ lang.SV0012 }}</span
            >
          </div>
        </div>
        <div class="form-group">
          <label for="inputTimeInSurveyView" class="col-md-4 control-label"
            >{{ lang.SV0002 }}*</label
          >
          <div
            class="col-md-8"
            @click="
              globals.toggleFlatpickr('inputTimeInSurveyView'),
                inputMetaInformationDisabled ||
                  validateInput('inputTimeInSurveyView')
            "
          >
            <input
              type="text"
              class="form-control"
              id="inputTimeInSurveyView"
              @change="validateInput('inputTimeInSurveyView')"
              :disabled="inputMetaInformationDisabled"
            />
            <span
              v-show="inputHasError('inputTimeInSurveyView')"
              class="help-block error text-danger"
              >{{ lang.SV0012 }}</span
            >
          </div>
        </div>
        <div class="form-group">
          <label for="inputTimeOutSurveyView" class="col-md-4 control-label"
            >{{ lang.SV0003 }}*</label
          >
          <div
            class="col-md-8"
            @click="
              globals.toggleFlatpickr('inputTimeOutSurveyView'),
                inputMetaInformationDisabled ||
                  validateInput('inputTimeOutSurveyView')
            "
          >
            <input
              type="text"
              class="form-control"
              id="inputTimeOutSurveyView"
              @change="validateInput('inputTimeOutSurveyView')"
              :disabled="inputMetaInformationDisabled"
            />
            <span
              v-show="inputHasError('inputTimeOutSurveyView')"
              class="help-block error text-danger"
              >{{ lang.SV0012 }}</span
            >
          </div>
        </div>
        <div class="form-group" v-if="!feature.isAudiTarget">
          <label for="inputGPSSurveyViewLat" class="col-md-4 control-label">{{
            lang.SV0045
          }}</label>
          <div class="col-md-8">
            <input
              type="number"
              step="any"
              min="-90"
              max="90"
              class="form-control"
              id="inputGPSSurveyViewLat"
              :disabled="inputMetaInformationDisabled"
            />
            <span class="help-block error text-danger">{{ lang.SV0058 }}</span>
          </div>
        </div>
        <div class="form-group" v-if="!feature.isAudiTarget">
          <label for="inputGPSSurveyViewLong" class="col-md-4 control-label">{{
            lang.SV0046
          }}</label>
          <div class="col-md-8">
            <input
              type="number"
              step="any"
              min="-180"
              max="180"
              class="form-control"
              id="inputGPSSurveyViewLong"
              :disabled="inputMetaInformationDisabled"
            />
            <span class="help-block error text-danger">{{ lang.SV0058 }}</span>
          </div>
        </div>
        <div class="form-group">
          <label for="txtMemoShopper" class="control-label">{{
            lang.SV0004
          }}</label>
          <textarea
            class="form-control"
            rows="4"
            id="txtMemoShopper"
            :disabled="
              globals.currentUserRole > 3 || surveyInstanceStatusId > 200
            "
          ></textarea>
        </div>
        <div class="form-group">
          <label for="txtMemoAgency" class="control-label">{{
            lang.SV0005
          }}</label>
          <textarea
            class="form-control"
            rows="4"
            id="txtMemoAgency"
            :disabled="
              globals.currentUserRole > 2 || surveyInstanceStatusId > 200
            "
          ></textarea>
        </div>
        <div class="form-group" v-if="!feature.isAudiTarget">
          <label for="txtMemoMSM" class="control-label">{{
            lang.SV0006
          }}</label>
          <textarea
            class="form-control"
            rows="4"
            id="txtMemoMSM"
            :disabled="
              globals.currentUserRole > 1 || surveyInstanceStatusId > 200
            "
          ></textarea>
        </div>
        <div class="form-group">
          <div
            class="attachment-download-container"
            v-if="surveyData && surveyData.SurveyAttachments"
            @click="
              globals.downloadFile(surveyData.SurveyAttachments[0].DownloadId)
            "
          >
            <a
              class="btn btn-default btn-fab btn-fab-mini"
              id="attachmentDownloadButton"
            >
              <i class="material-icons">attach_file</i>
            </a>
            <label for="attachmentDownloadButton" style="cursor: pointer">
              {{
                surveyData.SurveyAttachments[0].DownloadDescription
                  ? surveyData.SurveyAttachments[0].DownloadDescription
                  : surveyData.SurveyAttachments[0].DownloadFileName
              }}
            </label>
          </div>
        </div>
      </div>
      <hr class="hidden-lg" />
      <div class="col-lg-9 col-xs-12 col-lg-pull-3">
        <survey v-if="surveyData" :survey="survey"></survey>
      </div>
    </div>
    <div class="panel-footer" v-if="survey">
      <div class="navigation">
        <button
          class="btn btn-raised"
          @click="survey.prevPage()"
          :disabled="prevButtonDisabled"
        >
          {{ lang.SV0007 }}
        </button>
        <button
          class="btn btn-raised"
          @click="survey.nextPage()"
          :disabled="nextButtonDisabled"
        >
          {{ lang.SV0008 }}
        </button>
        <button
          class="btn btn-raised btn-success"
          @click="validateSurvey()"
          :disabled="
            !globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Update') ||
            completeButtonDisabled ||
            saveRequestPending
          "
        >
          {{ globals.currentUserRole == 3 ? lang.SV0009 : lang.SV0027 }}
          <i class="material-icons md-24" v-if="globals.currentUserRole == 3"
            >flag</i
          >
        </button>
      </div>
      <div
        class="status-switch-container"
        v-if="
          globals.currentUserRole < 3 &&
          globals.isAccessAllowed('LoopOp_SurveyInstances_Update')
        "
      >
        <button
          class="btn btn-raised"
          @click="moveCheckTo('shopper')"
          :disabled="moveToShopperButtonDisabled"
        >
          {{ lang.SV0024 }}
        </button>
        <button
          v-if="globals.currentUserRole == 1 || globals.isLeadAgencyUser"
          class="btn btn-raised"
          @click="moveCheckTo('agency')"
          :disabled="moveToAgencyButtonDisabled"
        >
          {{ feature.isAudiTarget ? lang.SV0069 : lang.SV0025 }}
        </button>
        <button
          v-if="!feature.isAudiTarget"
          class="btn btn-raised"
          @click="moveCheckTo('msm')"
          :disabled="moveToMSMButtonDisabled"
        >
          {{ feature.isAudiTarget ? lang.SV0070 : lang.SV0026 }}
        </button>
        <button
          v-if="globals.currentUserRole == 1 || globals.isLeadAgencyUser"
          class="btn btn-raised"
          @click="moveCheckTo('msminternal')"
          :disabled="moveToMSMInternalButtonDisabled"
        >
          {{ lang.SV0028 }}
        </button>
      </div>
      <div class="options">
        <button
          type="button"
          class="btn btn-raised"
          :class="{ hidden: !isClosableWindow }"
          @click="exitSurvey()"
        >
          {{ lang.SV0010 }}
        </button>
        <button
          type="button"
          class="btn btn-raised dialog-btn-primary"
          @click="saveSurvey(false)"
          :disabled="
            !globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Update') ||
            saveButtonDisabled
          "
        >
          {{ lang.SV0011 }}
        </button>
      </div>
    </div>

    <survey-upload-dialog
      :showDialog="showUploadDialog"
      :questionData="questionData"
      @dialogDataSaved="onUploadDialogDataSaved"
      @dialogClosed="onSurveyUploadDialogClosed"
    ></survey-upload-dialog>
  </div>
</template>

<script>
import * as SurveyVue from "survey-vue";
import Inputmask from "inputmask";
import Select2 from "../Tools/Select2";

import SurveyUploadDialog from "./SurveyUploadDialog";
var Survey = SurveyVue.Survey;

export default {
  name: "SurveyView",
  components: { "survey-upload-dialog": SurveyUploadDialog, Select2 },
  props: {
    selectedSurveyInstanceFromParent: Number,
    displayOnlyMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showUploadDialog: false,
      surveyInstanceId: "",
      surveyLocaleCode: "",
      survey: new SurveyVue.Model(),
      surveyData: null,
      saveRequestPending: false,
      surveyInstanceStatusId: -1,
      fpDate: null,
      fpTimeIn: null,
      fpTimeOut: null,
      fpInstancesFromSurvey: [],
      invalidInputIds: [],
      inputMetaInformationDisabled: false,
      saveButtonDisabled: true,
      prevButtonDisabled: true,
      nextButtonDisabled: true,
      completeButtonDisabled: true,
      moveToShopperButtonDisabled: true,
      moveToAgencyButtonDisabled: true,
      moveToMSMButtonDisabled: true,
      moveToMSMInternalButtonDisabled: true,
      metaInformation: {},
      dynamicPanels: null,
      currentRouterPath: "",
      isClosableWindow: false,
      questionData: {
        acceptedTypes: null,
        questionContent: null,
        questionName: "",
        questionId: "",
        allowMultipleFiles: false,
      },
      singleInputTypes: [
        "date",
        "datetime",
        "email",
        "number",
        "tel",
        "time",
        "url",
        "currency",
      ],
      lang: {
        SV0000: "Meta information",
        SV0001: "Date",
        SV0002: "Time in",
        SV0003: "Time out",
        SV0004: "Memo Shopper",
        SV0005: "Memo Agency",
        SV0006: "Memo MSM",
        SV0007: "Prev",
        SV0008: "Next",
        SV0009: "Complete",
        SV0010: "Close",
        SV0011: "Save",
        SV0012: "This information is required!",
        SV0013: "Survey Instance Id",
        SV0014: "Survey Id",
        SV0015: "Survey Instance Guid",
        SV0016: "Location Store Id",
        SV0017: "Location Name",
        SV0018: "Location Address",
        SV0019: "Location Country",
        SV0020: "Scenario Name",
        SV0021: "Wave Name",
        SV0022: "Instructions",
        SV0023: "Edit Uploads",
        SV0024: "Move to shopper",
        SV0025: "Move to agency",
        SV0026: "Move to MSM",
        SV0027: "Validate",
        SV0028: "Internal Review",
        SV0029: "Score",
        SV0030: "Estimated - Relevant are the reporting results",
        SV0031: "Validation error - please check your inputs!",
        SV0038: "Close Survey",
        SV0039: "Yes",
        SV0040: "No",
        SV0041: "There are unsaved changes for this survey.",
        SV0042: "Do you really want to quit without saving?",
        SV0045: "Position latitude",
        SV0046: "Position longitude",
        SV0051: "Language",
        SV0052: "Change language",
        SV0053: "Save",
        SV0054: "Discard",
        SV0055:
          "There are unsaved changes that will be lost after switching the survey language.",
        SV0056: "Do you want to save the current changes?",
        SV0057: "Check Info",
        SV0058: "Invalid value",
        SV0059: "Wave Info",
        SV0060: "Audi car model distribution",
        SV0061: "Show check history",
        SV0062: "Competitor car distribution",
        SV0063: "Shopper",
        SV0064: "Age",
        SV0065: "Gender",
        SV0066: "Car",
        SV0067: "Target segment",
        SV0068: "Target model",
        SV0069: "Move to local agency",
        SV0070: "Move to lead agency",
      },
      requiredFields: [
        "inputDateSurveyView",
        "inputTimeInSurveyView",
        "inputTimeOutSurveyView",
      ],
    };
  },
  created() {
    this.configureSurveyJs();
    this.initializeSurveyDesign();
  },
  mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.getSurveyViewLocalization();

      this.initializeDataFromParent();
      this.getSurveyDataByInstanceId();
    }
    this.currentRouterPath = this.$route.path;
    this.isClosableWindow = !!window.opener;
  },
  destroyed() {
    if (this.fpDate) this.fpDate.destroy();
    if (this.fpTimeIn) this.fpTimeIn.destroy();
    if (this.fpTimeOut) this.fpTimeOut.destroy();
    for (let instance of this.fpInstancesFromSurvey)
      if (instance) instance.destroy();
  },
  methods: {
    openSurveyUploadDialog() {
      if (this.survey && this.survey.data) {
        if (this.dynamicPanels && this.dynamicPanels.length > 0) {
          let questionPanel = this.dynamicPanels.filter(
            (panel) => panel.elements[0].id === this.questionData.questionId
          );
          if (questionPanel.length > 0)
            this.questionData.questionContent = _.cloneDeep(
              questionPanel[0].elements[0].value
            );
          else if (this.survey.data[this.questionData.questionName])
            this.questionData.questionContent = _.cloneDeep(
              this.survey.data[this.questionData.questionName]
            );
        } else if (this.survey.data[this.questionData.questionName])
          this.questionData.questionContent = _.cloneDeep(
            this.survey.data[this.questionData.questionName]
          );
      }
      this.showUploadDialog = true;
    },
    onSurveyUploadDialogClosed() {
      this.questionData.questionContent = null;
      this.showUploadDialog = false;
    },
    onUploadDialogDataSaved(filesToSave) {
      var questionName = filesToSave.questionName;
      var filesToDelete = filesToSave.filesToDeleteInSurvey;

      if (filesToSave.files.length > 0 || filesToDelete.length > 0)
        this.saveButtonDisabled = false;

      if (filesToSave.files.length > 0) {
        _.forEach(filesToSave.files, (file) => {
          // delete old files before adding the edited ones
          let idx;
          if (this.dynamicPanels && this.dynamicPanels.length > 0) {
            let dynPanelAnswers = this.survey.data.e99999;
            for (let i = 0; i < dynPanelAnswers.length; i++) {
              idx = _.findIndex(
                this.survey.data.e99999[i][questionName],
                (f) => f.name === file.name
              );
              if (idx > -1)
                this.survey.data.e99999[i][questionName].splice(idx, 1);
            }
          }
          let currentQuestion = this.survey.getQuestionByName(questionName);
          if (currentQuestion && currentQuestion.getType() === "file") {
            idx = _.findIndex(
              this.survey.data[questionName],
              (f) => f.name === file.name
            );
            currentQuestion.removeFile(file);
          }
        });
        if (this.dynamicPanels && this.dynamicPanels.length > 0) {
          let questionPanel = this.dynamicPanels.filter(
            (panel) => panel.elements[0].id === this.questionData.questionId
          );
          if (questionPanel.length > 0)
            questionPanel[0].elements[0].loadFiles(filesToSave.files);
          else
            this.survey
              .getQuestionByName(questionName)
              .loadFiles(filesToSave.files);
        } else {
          this.survey
            .getQuestionByName(questionName)
            .loadFiles(filesToSave.files);
        }
      }
      // remove deleted files in dialog in survey
      if (filesToDelete.length > 0) {
        if (this.dynamicPanels && this.dynamicPanels.length > 0) {
          let questionPanel = this.dynamicPanels.filter(
            (panel) => panel.elements[0].id === this.questionData.questionId
          );
          if (questionPanel.length > 0) {
            _.forEach(filesToDelete, (file) => {
              let idx = _.findIndex(
                questionPanel[0].elements[0].value,
                (f) => f.name === file.name
              );
              if (idx > -1) questionPanel[0].elements[0].value.splice(idx, 1);
              questionPanel[0].elements[0].removeFile(file);
            });
          } else {
            _.forEach(filesToDelete, (file) => {
              let idx = _.findIndex(
                this.survey.data[questionName],
                (f) => f.name === file.name
              );
              if (idx > -1) this.survey.data[questionName].splice(idx, 1);
              this.survey.getQuestionByName(questionName).removeFile(file);
            });
          }
        } else {
          _.forEach(filesToDelete, (file) => {
            let idx = _.findIndex(
              this.survey.data[questionName],
              (f) => f.name === file.name
            );
            if (idx > -1) this.survey.data[questionName].splice(idx, 1);
            this.survey.getQuestionByName(questionName).removeFile(file);
          });
        }
      }
    },
    showCheckHistory() {
      let config = {
        type: "SurveyInstance",
        guid: this.metaInformation.SurveyInstanceGuid,
        id: this.metaInformation.SurveyInstanceId,
      };
      this.globals.$emit("showElementHistory", config);
    },
    configureSurveyJs() {
      // Register functions for expression trigger and add maxPointsReached for selectbase questions
      SurveyVue.FunctionFactory.Instance.register("setMaxPoints", (params) => {
        if (params.length < 1 || !this.survey) return;
        for (let i = 0; i < params.length; i++) {
          let q = this.survey.getQuestionByName(params[i]);
          if (q) q.maxPointsReached = true;
        }
      });
      SurveyVue.FunctionFactory.Instance.register(
        "unsetMaxPoints",
        (params) => {
          if (params.length < 1 || !this.survey) return;
          for (let i = 0; i < params.length; i++) {
            let q = this.survey.getQuestionByName(params[i]);
            if (q && q.maxPointsReached) q.maxPointsReached = false;
          }
        }
      );
      SurveyVue.JsonObject.metaData.addProperty("selectbase", {
        name: "maxPointsReached:boolean",
      });
      SurveyVue.JsonObject.metaData.addProperty("panel", {
        name: "isCluster:boolean",
      });
      SurveyVue.JsonObject.metaData.addProperty("panel", {
        name: "backgroundColor:text",
      });
      SurveyVue.JsonObject.metaData.addProperty(
        "question",
        "commentForShopper:text"
      );

      SurveyVue.JsonObject.metaData.addProperty(
        "checkbox",
        "exclusiveValue:checkboxValue"
      );

      // Add points to answers
      SurveyVue.JsonObject.metaData.addClass(
        "itemvaluesWithPoints",
        ["points:number"],
        null,
        "itemvalue"
      );
      SurveyVue.JsonObject.metaData.addProperty(
        "selectbase",
        "choices:itemvalues"
      );
      let property1 = SurveyVue.JsonObject.metaData.findProperty(
        "selectbase",
        "choices"
      );
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      SurveyVue.JsonObject.metaData.addProperty(
        "rating",
        "rateValues:itemvalues"
      );
      property1 = SurveyVue.JsonObject.metaData.findProperty(
        "rating",
        "rateValues"
      );
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      // Add maxPoints to answers of radiogroups
      SurveyVue.JsonObject.metaData.addClass(
        "itemvaluesWithPointsAndMaxPoints",
        ["points:number", "maxPoints:number"],
        null,
        "itemvalue"
      );
      SurveyVue.JsonObject.metaData.addProperty(
        "radiogroup",
        "choices:itemvalues"
      );
      let property2 = SurveyVue.JsonObject.metaData.findProperty(
        "radiogroup",
        "choices"
      );
      property2.typeValue = "itemvaluesWithPointsAndMaxPoints";
      property2.className = "itemvaluesWithPointsAndMaxPoints";

      SurveyVue.JsonObject.metaData.addProperty("question", {
        name: "pointsMax:number",
      });

      SurveyVue.JsonObject.metaData.addProperty("question", "guid");
      SurveyVue.JsonObject.metaData.addProperty("panelbase", "guid");
      SurveyVue.JsonObject.metaData.addProperty("itemvalue", "guid");

      // Add custom question numbers
      SurveyVue.JsonObject.metaData.addProperty("question", {
        name: "customQuestionNumber",
        default: 0,
      });

      // Add properties for currency inputs
      SurveyVue.JsonObject.metaData.addProperty("survey", {
        name: "currencySymbol",
        default: "€",
      });
      SurveyVue.JsonObject.metaData.addProperty("survey", {
        name: "currencyDecimalPoint",
        default: "comma",
      });
    },
    initializeSurveyDesign() {
      var mainColor = $(":root").css("--color-primary-input");
      var mainHoverColor = $(":root").css("--color-primary-input-hover");
      var textColor = "#4a4a4a";
      var headerColor = "#160ce8";
      var headerBackgroundColor = "#4a4a4a";
      var bodyContainerBackgroundColor = "#f8f8f8";
      var defaultThemeColorsSurvey =
        SurveyVue.StylesManager.ThemeColors["default"];
      defaultThemeColorsSurvey["$main-color"] = mainColor;
      defaultThemeColorsSurvey["$main-hover-color"] = mainHoverColor;
      defaultThemeColorsSurvey["$text-color"] = textColor;
      defaultThemeColorsSurvey["$header-color"] = headerColor;
      defaultThemeColorsSurvey[
        "$header-background-color"
      ] = headerBackgroundColor;
      defaultThemeColorsSurvey[
        "$body-container-background-color"
      ] = bodyContainerBackgroundColor;
      SurveyVue.StylesManager.applyTheme("bootstrapmaterial");
    },
    validateSurvey() {
      this.survey.completeLastPage();
    },
    validateInput(id) {
      var result = document.getElementById(id).value !== "";
      if (result) {
        $("#" + id)
          .parent()
          .parent()
          .removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id)
          .parent()
          .parent()
          .addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },
    // Returns true if an input has a validation error, otherwise false
    inputHasError(id) {
      return this.invalidInputIds.indexOf(id) > -1 ? true : false;
    },
    resetValidationErrors(id) {
      var elements = $("#" + id).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          $("#" + elements[i].id)
            .parent()
            .parent()
            .removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    initializeDataFromParent() {
      this.surveyInstanceId = this.selectedSurveyInstanceFromParent;

      if (this.$route.params.surveyInstanceId)
        this.surveyInstanceId = this.$route.params.surveyInstanceId;
    },
    changeSurveyLanguage() {
      if (!this.saveButtonDisabled) {
        this.globals.$off(
          "ChangeCheckLanguageWithUnsavedChangesYesConfirmation"
        );
        this.globals.$once(
          "ChangeCheckLanguageWithUnsavedChangesYesConfirmation",
          () => {
            this.saveSurvey(false);
          }
        );
        this.globals.$off("ChangeCheckLanguageWithUnsavedChangesDialogClosed");
        this.globals.$once(
          "ChangeCheckLanguageWithUnsavedChangesDialogClosed",
          () => {
            this.getSurveyDataByInstanceId();
          }
        );

        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "ChangeCheckLanguageWithUnsavedChanges",
          confirmationTitle: this.lang.SV0052,
          yesButtonText: this.lang.SV0053,
          noButtonText: this.lang.SV0054,
          htmlText: `<p><b>${this.lang.SV0055}<br><br>${this.lang.SV0056}</b></p>`,
        });
      } else this.getSurveyDataByInstanceId();
    },
    initializeFlatpickr() {
      this.fpDate = flatpickr(
        "#inputDateSurveyView",
        this.globals.flatpickrDateConfig
      );
      if (Array.isArray(this.fpDate)) location.reload(); // Workaround for initialization error after opening surveyview in multiple tabs at the same time
      if (this.inputMetaInformationDisabled) {
        this.fpDate._input.setAttribute("disabled", true);
      }
      this.fpTimeIn = flatpickr(
        "#inputTimeInSurveyView",
        this.globals.flatpickrTimeConfig
      );
      this.fpTimeOut = flatpickr(
        "#inputTimeOutSurveyView",
        this.globals.flatpickrTimeConfig
      );
    },
    getSurveyDataByInstanceId() {
      this.resetValidationErrors("meta-information-container");
      let queryString = "api/SurveyInstancesAnswers/" + this.surveyInstanceId;
      if (this.surveyLocaleCode)
        queryString += "?localeCode=" + this.surveyLocaleCode;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.surveyData = data;
          this.surveyInstanceStatusId = data.SurveyInstanceStatusId;
          this.survey = new SurveyVue.Model(this.surveyData.Survey);
          this.surveyLocaleCode = data.LocaleCode;
          let languageCode = data.LocaleCode.substring(0, 2).toLowerCase();
          let frontendLanguage = this.globals.selectedLanguage
            .substring(0, 2)
            .toLowerCase();
          if (
            Object.keys(SurveyVue.surveyLocalization.locales).indexOf(
              languageCode
            ) > -1
          )
            SurveyVue.surveyLocalization.currentLocale = languageCode;
          else if (
            Object.keys(SurveyVue.surveyLocalization.locales).indexOf(
              frontendLanguage
            ) > -1
          )
            SurveyVue.surveyLocalization.currentLocale = frontendLanguage;
          else SurveyVue.surveyLocalization.currentLocale = "en";

          this.inputMetaInformationDisabled = data.SurveyInstanceAnswerReadOnly;
          if (this.displayOnlyMode || data.SurveyInstanceAnswerReadOnly) {
            this.survey.mode = "display";
          }

          // Fix for dynamic panels showing up with too low panel count
          let dynPanelUploads = this.survey.getQuestionByName("e99999");
          if (dynPanelUploads) {
            let dynPanelMinCount = dynPanelUploads.minPanelCount || 0;
            if (
              this.surveyData.SurveyInstanceAnswer &&
              this.surveyData.SurveyInstanceAnswer.e99999
            ) {
              let missingUploadsCount =
                dynPanelMinCount -
                this.surveyData.SurveyInstanceAnswer.e99999.length;
              if (missingUploadsCount > 0)
                for (let i = 0; i < missingUploadsCount; i++)
                  this.surveyData.SurveyInstanceAnswer.e99999.push({});
            }
          }

          this.configureStatusButtonAccess();
          this.initializeSurvey();
          this.initializeFlatpickr();
          this.loadDataIntoForm();
          this.readMaxPointsReachedFromResult();
          this.saveButtonDisabled = true;
          this.$nextTick(() => {
            this.getMetaInformation();
          });
          this.$emit("surveyDataReceived");
        },
        error: () => {
          console.error("Error in getSurveyDataByInstanceId");
          this.globals.showErrorSnackbar("Survey request failed");
        },
      });
    },

    // Requests localization data for the survey view
    getSurveyViewLocalization() {
      $.ajax({
        method: "GET",
        url: "api/Language/ComponentTranslation/SurveyView",
        success: (data) => {
          if (data && data.length > 0) {
            SurveyVue.surveyLocalization.locales[data[0].LanguageCode] =
              data[0].Translation;
          }
          let newLocale = this.globals.selectedLanguage
            .substring(0, 2)
            .toLowerCase();
          SurveyVue.surveyLocalization.defaultLocale = newLocale;
        },
        error: () => {
          console.error(
            "Localization data access failed in getSurveyViewLocalization()"
          );
          this.globals.showErrorSnackbar("Localization data access failed");
        },
      });
    },

    configureStatusButtonAccess() {
      let currentStatus = this.surveyInstanceStatusId;
      if (!currentStatus) return;

      this.moveToShopperButtonDisabled = true;
      this.moveToAgencyButtonDisabled = true;
      this.moveToMSMButtonDisabled = true;
      this.moveToMSMInternalButtonDisabled = true;

      this.moveToShopperButtonDisabled =
        _.indexOf([120, 140, 170, 190, 200], currentStatus) < 0 ? true : false;
      if (this.globals.isLocalAgencyUser && currentStatus > 160)
        this.moveToShopperButtonDisabled = true;

      if (this.globals.isLocalAgencyUser && currentStatus >= 150) {
        this.moveToShopperButtonDisabled = false;
      }

      this.moveToAgencyButtonDisabled =
        _.indexOf([160, 170, 190, 200], currentStatus) < 0 ? true : false;

      this.moveToMSMButtonDisabled =
        _.indexOf([150], currentStatus) < 0 ? true : false;

      this.moveToMSMInternalButtonDisabled =
        _.indexOf([120, 160, 165, 190, 200], currentStatus) < 0 ? true : false;
    },
    getMetaInformation() {
      this.calcPointsOfContainer(this.survey);

      this.metaInformation = {
        SurveyId: this.surveyData.SurveyId,
        SurveyInstanceId: this.surveyData.SurveyInstanceId,
        SurveyInstanceGuid: this.surveyData.SurveyInstanceGuid,
        ShortSurveyCode: this.surveyData.ShortSurveyCode,
        LocationStoreId: this.surveyData.LocationStoreId,
        LocationName: this.surveyData.LocationName,
        LocationAddress: this.surveyData.LocationAddress,
        LocationCountry: this.surveyData.LocationCountry,
        ScenarioName: this.surveyData.ScenarioName,
        WaveName: this.surveyData.WaveName,
        CarModelDistribution: this.surveyData.CarModelDistribution,
        CompetitorCarModelDistribution: this.surveyData
          .CompetitorCarModelDistribution,
        WaveInfo: this.surveyData.WaveInfo,
        SurveyInstanceInfo: this.surveyData.SurveyInstanceInfo,
        Score: `(${this.survey.pointsReached}/${this.survey.pointsMax})`,
      };
      if (this.surveyData.ApprovedShopper)
        this.metaInformation.ApprovedShopper = this.surveyData.ApprovedShopper;
    },
    loadDataIntoForm() {
      // load result set of an existing survey
      if (this.surveyData.SurveyInstanceAnswer) {
        this.survey.data = this.surveyData.SurveyInstanceAnswer;
      }
      // load time and memo information
      if (this.surveyData.SurveyInstanceAnswerDateOfVisit) {
        this.fpDate.setDate(
          this.surveyData.SurveyInstanceAnswerDateOfVisit,
          true,
          "Y-m-d"
        );
      }
      if (this.surveyData.SurveyInstanceAnswerTimeIn) {
        this.fpTimeIn.setDate(
          this.surveyData.SurveyInstanceAnswerTimeIn,
          true,
          "H:i"
        );
      }
      if (this.surveyData.SurveyInstanceAnswerTimeOut) {
        this.fpTimeOut.setDate(
          this.surveyData.SurveyInstanceAnswerTimeOut,
          true,
          "H:i"
        );
      }
      if (
        this.surveyData.SurveyInstanceAnswerPosition &&
        this.surveyData.SurveyInstanceAnswerPosition.Latitude &&
        this.surveyData.SurveyInstanceAnswerPosition.Longitude
      ) {
        let latInput = document.getElementById("inputGPSSurveyViewLat");
        let longInput = document.getElementById("inputGPSSurveyViewLong");
        if (latInput)
          latInput.value = this.surveyData.SurveyInstanceAnswerPosition.Latitude;
        if (longInput)
          longInput.value = this.surveyData.SurveyInstanceAnswerPosition.Longitude;
      }
      if (this.surveyData.SurveyInstanceAnswerMemoShopper) {
        document.getElementById(
          "txtMemoShopper"
        ).value = this.surveyData.SurveyInstanceAnswerMemoShopper;
      }
      if (this.surveyData.SurveyInstanceAnswerMemoAgency) {
        document.getElementById(
          "txtMemoAgency"
        ).value = this.surveyData.SurveyInstanceAnswerMemoAgency;
      }
      if (this.surveyData.SurveyInstanceAnswerMemoMSM) {
        let msmMemoInput = document.getElementById("txtMemoMSM");
        if (msmMemoInput)
          msmMemoInput.value = this.surveyData.SurveyInstanceAnswerMemoMSM;
      }
    },
    initializeSurvey() {
      // disable survey buttons
      this.survey.showNavigationButtons = false;
      // initialize survey events
      this.survey.onComplete.add((survey) => {
        // disable buttons
        this.prevButtonDisabled = true;
        this.nextButtonDisabled = true;
        this.completeButtonDisabled = true;
        this.saveButtonDisabled = true;
        // save to backend
        this.saveSurvey(true);
      });
      this.survey.onCompleting.add((survey, options) => {
        let validationResult = true;
        this.requiredFields.forEach((field) => {
          validationResult = this.validateInput(field) && validationResult;
        });
        this.survey.isCurrentPageHasErrors;
        if (!validationResult) {
          this.globals.showErrorSnackbar(this.lang.SV0031);
          options.allowComplete = false;
          survey.clear(false, false);
          let currPage = survey.currentPage;
          this.$nextTick(() => {
            survey.currentPage = currPage;
          });
          return;
        }
      });
      this.survey.onCurrentPageChanged.add((survey) => {
        this.doOnCurrentPageChanged();
      });
      this.survey.onValueChanged.add((sender, options) => {
        // enable save button only when survey changed
        this.saveButtonDisabled = false;
      });
      this.survey.onAfterRenderPage.add((sender, options) => {
        // activate save button on input event for input type text and number and textarea
        var inputs = document.querySelectorAll(
          "#surveyViewForm input, #surveyViewForm textarea"
        );
        for (var i = 0; i < inputs.length; i++) {
          inputs[i].oninput = (input) => {
            this.saveButtonDisabled = false;
          };
        }
      });
      this.doOnCurrentPageChanged();

      // Some visual fixes for read only surveys
      this.survey.onAfterRenderPage.add((sender, options) => {
        if (sender.mode === "display") {
          $(".sv_qstn .radio input:disabled, .sv_qstn .checkbox input:disabled")
            .parent()
            .css("cursor", "not-allowed")
            .css("color", "grey");
          $(".sv_qstn textarea:read-only").prop("disabled", true);
        }
      });

      // Set prevValue for exclusive property on survey load
      this.survey.onAfterRenderSurvey.add((survey, options) => {
        let questions = survey.getAllQuestions(false);
        for (let i = 0; i < questions.length; i++) {
          if (questions[i].getType() === "checkbox") {
            questions[i].prevValue = _.clone(questions[i].value);
          }
        }
      });

      // Avoid opening upload modal on enter inside survey form
      this.survey.onAfterRenderSurvey.add((sender, options) => {
        $(options.htmlElement)
          .find("form")
          .on("keypress", (e) => {
            if (e.target.tagName === "TEXTAREA") return true;
            let keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
              return false;
            }
          });
      });

      // Add functionality for exclusiveValue property
      this.survey.onValueChanged.add(function (sender, options) {
        var q = options.question;
        //If question is not defined or question is not checkbox or exclusiveValue does not exist do nothing
        if (!q || q.getType() != "checkbox" || !q.exclusiveValue) return;
        //returns if the value set for the first time or there is nothing to do
        if (!q.prevValue || !options.value) {
          q.prevValue = options.value;
          return;
        }
        var index = options.value.indexOf(q.exclusiveValue);
        //has "None of the above selected"
        if (index > -1) {
          //"None of the above selected" was selected before
          if (q.prevValue.indexOf(q.exclusiveValue) > -1) {
            var value = options.value;
            value.splice(index, 1);
            q.value = value;
          } else {
            //none select just now
            q.value = [q.exclusiveValue];
          }
        }
        q.prevValue = _.clone(q.value);
      });

      // Trigger validation after changing question value
      this.survey.onValueChanged.add((sender, options) => {
        if (!options.question) return;
        options.question.hasErrors(true);
      });
      // Select cluster background color in test survey
      this.survey.onUpdatePanelCssClasses.add((sender, options) => {
        if (!options.panel.isCluster) return;
        let pName = options.panel.name;
        let panelContainer = options.cssClasses.panel.container;
        if (panelContainer.indexOf(pName) < 0) {
          panelContainer += " background-" + pName;
          options.cssClasses.panel.container = panelContainer;
        }
      });
      // Add background color to clusters
      this.survey.onAfterRenderPage.add((sender, options) => {
        for (let el of options.page.elements) {
          if (el.isCluster) {
            $(".background-" + el.name).css("background", el.backgroundColor);
          }
        }
      });
      // Set inputmask or datepicker for available input types in survey
      this.survey.onAfterRenderQuestion.add((survey, options) => {
        let inputMaskConfig, el, fp;

        for (let type of this.singleInputTypes) {
          el = $(options.htmlElement).find('input[type="' + type + '"]');
          if (el.length < 1) continue;
          if (type !== "number") $(el).prop("type", "text");

          inputMaskConfig = {
            clearIncomplete: true,
          };

          switch (type) {
            case "date":
              fp = flatpickr("#" + el[0].id, this.globals.flatpickrDateConfig);
              fp.setDate(options.question.value, true, "Y-m-d");
              break;
            case "datetime":
              fp = flatpickr(
                "#" + el[0].id,
                this.globals.flatpickrDatetimeConfig
              );
              fp.setDate(options.question.value, true, "Y-m-d H:i");
              break;
            case "email":
              inputMaskConfig.alias = "email";
              break;
            case "number":
              inputMaskConfig.alias = "numeric";
              inputMaskConfig.rightAlign = false;
              inputMaskConfig.inputType = "number";
              break;
            case "tel":
              inputMaskConfig.mask = "+(99[9]) 9{2,14}";
              break;
            case "time":
              fp = flatpickr("#" + el[0].id, this.globals.flatpickrTimeConfig);
              fp.setDate(options.question.value, true, "H:i");
              break;
            case "url":
              inputMaskConfig.regex = "(https?|ftp)://.*";
              break;
            case "currency":
              inputMaskConfig.alias = "currency";
              inputMaskConfig.placeholder = "_";
              inputMaskConfig.clearIncomplete = false;
              inputMaskConfig.rightAlign = false;
              inputMaskConfig.tabThrough = true;
              inputMaskConfig.positionCaretOnClick = "select";

              inputMaskConfig.autoUnmask = true;
              inputMaskConfig.onBeforeMask = function (value, opts) {
                let newValue = value.toString();
                let radixPointIndex = newValue.indexOf(".");
                if (radixPointIndex > -1) {
                  if (!newValue[radixPointIndex + 2]) newValue = newValue + "0";
                } else newValue = newValue + ".00";

                newValue = newValue.replace(".", opts.radixPoint);
                return newValue;
              };
              inputMaskConfig.onUnMask = function (
                maskedValue,
                unmaskedValue,
                opts
              ) {
                if (unmaskedValue === "" && opts.nullable === true) {
                  return unmaskedValue;
                }
                let stringValue = maskedValue.replace(opts.prefix, "");
                stringValue = stringValue.replace(
                  new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"),
                  ""
                );
                if (opts.placeholder.charAt(0) !== "") {
                  stringValue = stringValue.replace(
                    new RegExp(opts.placeholder.charAt(0), "g"),
                    "0"
                  );
                }

                if (inputMaskConfig.radixPoint === ",")
                  stringValue = stringValue.replace(",", ".");

                unmaskedValue = Number.parseFloat(stringValue);
                return unmaskedValue;
              };

              inputMaskConfig.prefix = survey.currencySymbol + " ";
              inputMaskConfig.groupSeparator =
                survey.currencyDecimalPoint === "comma" ? "." : ",";
              inputMaskConfig.radixPoint =
                survey.currencyDecimalPoint === "comma" ? "," : ".";

              if (!survey.getValue(options.question.name))
                survey.setValue(options.question.name, 0);
          }

          if (fp) {
            $(el[0].parentElement).on("click", (e) => {
              fp.toggle();
            });
            this.fpInstancesFromSurvey.push(fp);
          } else Inputmask(inputMaskConfig).mask(el);
        }
      });
      this.survey.onAfterRenderQuestion.add((survey, options) => {
        // add upload edit dialog to a file input question
        if (
          options.question.getType() === "file" &&
          this.survey.mode === "edit" &&
          $(window).width() >= 1200
        ) {
          let uploadDialog = `
            <div class="form-group">
              <button id="upload-${options.question.id}" class="btn btn-raised btn-upload">${this.lang.SV0023}</button> 
            </div>`;
          let btn_id = `upload-${options.question.id}`;
          $(document).on("click", "#" + btn_id, (e) => {
            e.preventDefault();
            this.questionData.questionName = options.question.name;
            this.questionData.questionId = options.question.id;
            this.questionData.acceptedTypes = options.question.acceptedTypes;
            this.questionData.allowMultipleFiles =
              options.question.allowMultiple;
            this.openSurveyUploadDialog();
          });
          $(options.htmlElement).append(uploadDialog);
        }
        // TODO: Will not work if there is more than one dynamic panel
        if (options.question.getType() === "paneldynamic")
          this.dynamicPanels = options.question.panels;

        // Add commentForShopper text to question template
        if (options.question.commentForShopper) {
          let comment = `
          <div class="shopper-comment-container small" 
            style="cursor: pointer;"
            aria-expanded="false"
            data-toggle="collapse" 
            data-target="#instructions-${options.question.name}">
            <div class="shopper-comment-header">
              <span><i class="material-icons md-add">add_circle_outline</i></span>
              <span><i class="material-icons md-remove">remove_circle_outline</i></span>
              <span class="shopper-comment-header-text">${this.lang.SV0022}</span>
            </div>
            <div id="instructions-${options.question.name}"
              class="collapse shopper-comment-content">
              ${options.question.commentForShopper}
            </div>
          </div>`;
          $(options.htmlElement).append(comment);
        }
      });
      this.survey.onDynamicPanelAdded.add((sender, options) => {
        this.dynamicPanels = options.question.panels;
      });
      this.survey.onDynamicPanelRemoved.add((sender, options) => {
        this.dynamicPanels = options.question.panels;
      });

      this.survey.onUploadFiles.add((sender, options) => {
        if (!this.globals.isAccessAllowed("LoopOp_Upload_Create")) {
          this.globals.showErrorSnackbar("Permission denied");
          options.callback("error");
          return;
        }
        let files = options.files;
        if (!files || !files[0]) {
          this.globals.showErrorSnackbar("Error on file upload");
          console.error("No upload file available");
          options.callback("error");
          return;
        }

        let uploadCount = files.length;
        let question = sender.getQuestionByName(options.name);
        let callbackData = [];

        files.forEach((file) => {
          let containsImage = _.startsWith(file.type, "image");

          if (question && question.acceptedTypes) {
            if (!this.globals.isValidFileType(file, question.acceptedTypes)) {
              this.globals.showErrorSnackbar(`Wrong file type: ${file.name}`);
              console.error(
                `file type mismatch: ${file.name} - accepted types: ${question.acceptedTypes}`
              );
              options.callback("error");
              return;
            }
          }

          let callback = () => {
            let uploadSuccess = (data) => {
              callbackData.push({
                file: file,
                content: data[0].DownloadId,
              });

              if (--uploadCount < 1) {
                options.callback("success", callbackData);
                this.globals.showSuccessSnackbar(
                  "Attachment upload successful"
                );
                this.globals.$emit("surveyAttachmentUploadComplete");
              }
            };
            let uploadError = () => {
              options.callback("error");
            };

            this.globals.uploadFile(file, uploadSuccess, uploadError);
          };
          file.imageUrl = URL.createObjectURL(file);
          if (containsImage)
            this.globals.getImageOrientation(file, (orientation) => {
              this.globals.resetImageOrientation(file, orientation, (data) => {
                file = data;
                callback();
              });
            });
          else callback();
        });
      });
      this.survey.onDownloadFile.add((sender, options) => {
        options.callback("success", "/api/download/" + options.content);
      });
      this.$surveyInitDone = true;
    },
    // collect data
    collectSurveyData(complete) {
      let surveydata = {
        SurveyInstanceAnswerDateOfVisit: document.getElementById(
          "inputDateSurveyView"
        ).value,
        LocaleCode: this.surveyLocaleCode,
        SurveyInstanceAnswerTimeIn: document.getElementById(
          "inputTimeInSurveyView"
        ).value,
        SurveyInstanceAnswerTimeOut: document.getElementById(
          "inputTimeOutSurveyView"
        ).value,
        SurveyInstanceAnswerMemoShopper: document.getElementById(
          "txtMemoShopper"
        ).value,
        SurveyInstanceAnswerMemoAgency: document.getElementById("txtMemoAgency")
          .value,
        SurveyInstanceAnswer: this.survey.data,
        SurveyInstanceProgress: complete ? 100 : this.calcSurveyProgress(),
      };
      let msmMemoInput = document.getElementById("txtMemoMSM");
      if (msmMemoInput)
        surveydata.SurveyInstanceAnswerMemoMSM = msmMemoInput.value;

      let latInput = document.getElementById("inputGPSSurveyViewLat");
      let lat = latInput && latInput.value;
      let longInput = document.getElementById("inputGPSSurveyViewLong");
      let long = longInput && longInput.value;
      if (lat && long)
        surveydata.SurveyInstanceAnswerPosition = {
          Latitude: parseFloat(lat),
          Longitude: parseFloat(long),
        };

      return surveydata;
    },
    saveSurveyToBackend(complete) {
      if (this.saveRequestPending) return;
      let surveyObject = this.collectSurveyData(complete);
      let queryString = `api/SurveyInstancesAnswers/${this.surveyInstanceId}`;

      this.getMetaInformation(); // Calculates score of survey and updates meta information
      surveyObject.SurveyInstanceAnswerPoints = this.survey.pointsReached;
      surveyObject.SurveyInstanceAnswerMaxPoints = this.survey.pointsMax;
      surveyObject.VisibleElements = this.getVisibleSurveyElements();
      surveyObject.SurveyInstanceNote = this.surveyData.SurveyInstanceNote;

      this.saveButtonDisabled = true;
      this.saveRequestPending = true;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: JSON.stringify(surveyObject),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: () => {
          if (complete) this.moveCheckTo("validation");
          else {
            if (
              this.globals.currentUserRole == 1 &&
              this.surveyInstanceStatusId === 200
            )
              this.moveCheckTo("msminternal", true);
          }
        },
        error: () => {
          console.error("Error on PUT in saveSurveyToBackend");
          this.globals.showErrorSnackbar("Survey update failed");
        },
        complete: () => {
          this.saveRequestPending = false;
        },
      });
    },
    moveCheckTo(type, keepSurveyOpen) {
      let newStatus;
      let currentStatus = this.surveyInstanceStatusId;

      if (type === "shopper") {
        if (_.indexOf([120, 140, 170, 190, 200], currentStatus) > -1)
          newStatus = 130;
        else if (
          _.indexOf([150, 170], currentStatus) > -1 &&
          this.globals.isLocalAgencyUser
        )
          newStatus = 130;
      } else if (type === "agency") {
        if (_.indexOf([160, 170, 190, 200], currentStatus) > -1)
          newStatus = 150;
      } else if (type === "msm") {
        if (_.indexOf([150], currentStatus) > -1) newStatus = 165;
      } else if (type === "msminternal") {
        if (_.indexOf([120, 160, 165, 190, 200], currentStatus) > -1)
          newStatus = 170;
      } else if (type === "validation") {
        if (_.indexOf([100, 110], currentStatus) > -1) newStatus = 120;
        else if (currentStatus === 130) newStatus = 140;
        else if (
          (currentStatus === 120 || currentStatus === 140) &&
          this.globals.currentUserRole > 1
        )
          newStatus = 160;
        else if (currentStatus === 150) newStatus = 165;
        else if (_.indexOf([120, 140, 160, 165, 170, 190], currentStatus) > -1)
          // 120 & 140 for MSM Users
          newStatus = 200;
      }

      if (newStatus) this.updateCheckStatus(newStatus, keepSurveyOpen);
    },
    updateCheckStatus(status, keepSurveyOpen) {
      if (!status) return;
      let sendData = {};
      sendData.SurveyInstanceIds = [this.surveyInstanceId];
      sendData.SurveyInstanceStatusId = status;
      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances",
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) this.globals.showErrorSnackbar(data.Error);
          else {
            this.surveyInstanceStatusId = status;
            this.globals.showSuccessSnackbar("Status update successful");
            if (this.globals.currentUserRole < 3 && !keepSurveyOpen) {
              this.globals.showSuccessSnackbar("Status update successful");
              setTimeout(function () {
                window.close();
              }, 1500);
            }
          }
        },
        error: () => {
          console.error("Error on PUT in updateCheckStatus()");
          this.globals.showErrorSnackbar("Status update failed");
        },
      });
    },
    addMaxPointsReachedToResult() {
      let resultData = this.survey.data;
      let questions = this.survey.getAllQuestions();
      let maxPointsQuestions = [];
      for (let q of questions) {
        if (q.maxPointsReached) {
          maxPointsQuestions.push(q.name);
        }
      }
      if (maxPointsQuestions.length > 0)
        resultData.maxPointsReached = maxPointsQuestions;
      else delete resultData.maxPointsReached;
      this.survey.data = resultData;
    },
    readMaxPointsReachedFromResult() {
      let resultData = this.survey.data;
      let maxPointsQuestions = resultData.maxPointsReached;
      if (maxPointsQuestions) {
        for (let qName of maxPointsQuestions) {
          let q = this.survey.getQuestionByName(qName);
          q.maxPointsReached = true;
        }
      }
    },
    exitSurvey(force) {
      if (!this.saveButtonDisabled && !force) {
        this.globals.$off("CloseSurveyWithUnsavedChangesModalYesConfirmation");
        this.globals.$once(
          "CloseSurveyWithUnsavedChangesModalYesConfirmation",
          () => {
            this.exitSurvey(true);
          }
        );

        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "CloseSurveyWithUnsavedChangesModal",
          confirmationTitle: this.lang.SV0038,
          colorRed: true,
          yesButtonText: this.lang.SV0039,
          noButtonText: this.lang.SV0040,
          htmlText: `<p><b>${this.lang.SV0041}<br><br>${this.lang.SV0042}</b></p>`,
        });
        return;
      }
      window.close();
    },
    saveSurvey(complete) {
      this.addMaxPointsReachedToResult();
      this.saveSurveyToBackend(complete);
    },
    doOnCurrentPageChanged() {
      // only one page
      if (this.survey.visiblePageCount == 1) {
        this.prevButtonDisabled = true;
        this.nextButtonDisabled = true;
        this.completeButtonDisabled = false;
      } else if (this.survey.isFirstPage) {
        // first page of many
        this.prevButtonDisabled = true;
        this.nextButtonDisabled = false;
        this.completeButtonDisabled = true;
      } else if (this.survey.isLastPage) {
        // last page
        this.prevButtonDisabled = false;
        this.nextButtonDisabled = true;
        this.completeButtonDisabled = false;
      } else {
        // between first and last page
        this.prevButtonDisabled = false;
        this.nextButtonDisabled = false;
        this.completeButtonDisabled = true;
      }
      if (
        this.surveyData.SurveyInstanceAnswerReadOnly ||
        this.surveyInstanceStatusId > 200 ||
        (this.displayOnlyMode &&
          (!this.surveyData.SurveyInstanceProgress ||
            this.surveyData.SurveyInstanceProgress < 100))
      )
        this.completeButtonDisabled = true;
    },
    calcSurveyProgress() {
      let visibleQuestions = this.survey.getAllQuestions(true);
      let requiredCount = 0;
      let answeredCount = 0;
      for (let i = 0; i < visibleQuestions.length; i++) {
        if (visibleQuestions[i].isRequired) {
          requiredCount++;
          if (!visibleQuestions[i].isEmpty()) answeredCount++;
        }
      }
      requiredCount += this.requiredFields.length;
      this.requiredFields.forEach((field) => {
        if (document.getElementById(field).value !== "") {
          answeredCount++;
        }
      });
      let result = Math.round((answeredCount / requiredCount) * 100);
      return result;
    },
    getVisibleSurveyElements() {
      let visibleElements = [];

      let visibleQuestions = this.survey.getAllQuestions(true);
      for (let q of visibleQuestions) {
        if (q.guid) visibleElements.push(q.guid);
        if (q.choices) {
          for (let choice of q.choices)
            if (choice.isVisible && choice.guid)
              visibleElements.push(choice.guid);
        }
      }
      let visiblePanels = this.survey.getAllPanels(true);
      for (let p of visiblePanels) {
        if (p.guid) visibleElements.push(p.guid);
      }
      return visibleElements;
    },
    // Calculates the points value of the given container element
    calcPointsOfContainer(container) {
      let type = container.getType();
      let containerTypes = ["panel", "page", "survey"];

      if (_.indexOf(containerTypes, type) < 0) return; // No container type
      container.pointsMax = 0;
      container.pointsReached = 0;
      let elements = type === "survey" ? container.pages : container.elements;

      for (let el of elements) {
        if (_.indexOf(containerTypes, el.getType()) > -1) {
          this.calcPointsOfContainer(el);
          container.pointsMax += el.pointsMax || 0;
          container.pointsReached += el.pointsReached || 0;
        } else {
          let qpoints = this.getPointsOfQuestion(el);
          container.pointsMax += qpoints.pointsMax;
          container.pointsReached += qpoints.pointsReached;
        }
      }
    },
    // Returns the points of a given question
    getPointsOfQuestion(question) {
      let points = { pointsMax: 0, pointsReached: 0 };
      let qtype = question.getType();
      if (!qtype || typeof question.value === "undefined") return points;

      if (_.indexOf(["text", "comment", "file"], qtype) > -1) {
        if (question.pointsMax) {
          points.pointsMax = question.pointsMax;
          points.pointsReached = question.pointsMax;
        }
      } else if (qtype === "checkbox") {
        if (question.value.length > 0) {
          if (question.pointsMax) points.pointsMax = question.pointsMax;
          for (let item of question.value) {
            let answer = _.find(question.choices, {
              value: item,
            });
            if (answer && answer.points) points.pointsReached += answer.points;
          }
        }
      } else if (qtype === "radiogroup") {
        let answer = _.find(question.choices, { value: question.value });
        if (answer) {
          if (answer.maxPoints) points.pointsMax = answer.maxPoints;
          else if (question.pointsMax) points.pointsMax = question.pointsMax;

          if (answer.points) points.pointsReached = answer.points;
        }
      } else if (qtype === "dropdown") {
        let answer = _.find(question.choices, { value: question.value });
        if (answer) {
          if (question.pointsMax) points.pointsMax = question.pointsMax;
          if (answer.points) points.pointsReached = answer.points;
        }
      } else if (qtype === "rating") {
        if (!question.rateValues || question.rateValues.length < 1) {
          if (question.pointsMax) {
            points.pointsMax = question.pointsMax;
            points.pointsReached = question.pointsMax;
          }
        } else {
          let answer = _.find(question.rateValues, { value: question.value });
          if (answer) {
            if (question.pointsMax) points.pointsMax = question.pointsMax;
            if (answer.points) points.pointsReached = answer.points;
          }
        }
      }
      return points;
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.getSurveyViewLocalization();

      if (this.$surveyInitDone) return;
      this.initializeDataFromParent();
      this.getSurveyDataByInstanceId();
    },
  },
};
</script>

<style>
#surveyViewForm .sv_qstn[id^="sq"],
#surveyViewForm .sv_p_container {
  border: 1px solid #e7eaec;
  padding: 20px 9px;
  margin: 18px 0;
}
#surveyViewForm .sv_p_container {
  border: 3px solid #d5d8da;
}
/* Set default background color of questions */
#surveyViewForm .sv_qstn {
  background: white;
}
/* Shopper comment */
#surveyViewForm .shopper-comment-container {
  padding: 10px 0 0 0;
}
#surveyViewForm .shopper-comment-header {
  font-size: 14px;
  padding-bottom: 5px;
}
#surveyViewForm .shopper-comment-content {
  padding-left: 10px;
}
#surveyViewForm .shopper-comment-header .material-icons {
  font-size: 22px;
}
#surveyViewForm .shopper-comment-container .material-icons {
  width: 20px;
  position: absolute;
}
#surveyViewForm .shopper-comment-header-text {
  padding-left: 30px;
}
#surveyViewForm .shopper-comment-container[aria-expanded="true"] .md-add {
  display: none;
}
#surveyViewForm .shopper-comment-container[aria-expanded="false"] .md-remove {
  display: none;
}
/* Darker label color in form groups */
#surveyViewForm .form-group .checkbox label,
#surveyViewForm .form-group .radio label,
#surveyViewForm .form-group label {
  color: rgb(80, 80, 80);
}

/* Improve fonts of titles */
#surveyViewForm h3 {
  font-weight: 400;
}
#surveyViewForm h4 {
  font-size: 22px;
}
#surveyViewForm h5 {
  font-size: 16px;
}

@media (max-width: 1000px) {
  #surveyViewForm h3 {
    font-size: 28px;
  }
  #surveyViewForm h4 {
    font-size: 26px;
  }
  #surveyViewForm h5 {
    font-size: 20px;
  }
}

/* Increase space between radiobuttons */
#surveyViewForm .radio + .radio {
  margin-top: 10px;
}

/* Fix text color for selected answer on rating questions */
#surveyViewForm .sv_qstn .btn-group > label.btn-secondary.active {
  color: white;
}

/* Hide X button on language change saving modal */
#ChangeCheckLanguageWithUnsavedChangesConfirmation .modal-header > button {
  display: none;
}

#surveyViewForm .btn-upload {
  background: rgb(197, 231, 194);
}
</style>

<style scoped>
#surveyViewPanel {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  text-align: left;
  margin: 0;
  overflow: auto;
  height: calc(100vh - 81px);
}

#surveyViewForm {
  padding: 0 !important;
  margin: 0;
}

@media (min-width: 1200px) {
  #surveyViewPanel > .panel-body {
    height: calc(100vh - 141px);
  }
  #surveyViewPanel > .panel-body > div {
    height: calc(100vh - 141px);
    overflow: auto;
  }
}

.panel-footer {
  position: fixed;
  width: 100%;
  bottom: 20px;
  z-index: 200;
  height: 61px;
  padding: 0 15px;
  display: -ms-grid;
  display: grid;
  grid-template-areas: "left middle right";
}
.panel-footer button {
  background-color: lightgrey;
  padding: 8px 15px;
}
.navigation {
  -ms-grid-column: 1;
  grid-area: left;
  padding: 2px 20px;
  box-sizing: border-box;
}
.options {
  -ms-grid-column: 2;
  text-align: right;
  grid-area: right;
  padding: 2px 20px;
  box-sizing: border-box;
}
.status-switch-container {
  grid-area: middle;
  padding: 2px 20px 2px 50px;
  box-sizing: border-box;
}
#meta-information-container .form-group {
  overflow: auto;
  padding: 0;
  margin: 0;
}
#meta-information-container .form-group > label,
#meta-information-container .form-group > div {
  padding: 0;
}
#approvedShopperDetailsContainer {
  font-size: 12px;
  padding-left: 40px;
}
.survey-logo-container {
  float: right;
  margin-left: 10px;
  height: 150px;
}
.survey-logo-container > img {
  max-height: 150px;
  max-width: 200px;
}
.attachment-download-container {
  cursor: pointer;
  padding: 10px !important;
}
.attachment-download-container > label {
  margin-left: 5px;
}
#meta-information-container .form-group.has-error {
  overflow: visible;
}
#meta-information-container .form-group .help-block {
  display: none;
}
#meta-information-container .form-group.has-error .help-block {
  display: block;
}
#meta-information-container .form-group.has-error + .form-group {
  clear: both;
  padding-top: 10px;
}

.panel-footer .btn.btn-success > i.material-icons {
  margin: -5px -5px -5px 5px;
}

hr {
  margin: 8px auto;
  height: 0;
  width: 100%;
  border-top: 5px solid #666666;
  border-radius: 2px;
}

#metaInformationHeader {
  font-size: 20px;
  font-weight: bold;
}

#showCheckHistoryInfoIcon {
  position: relative;
  left: 10px;
  margin: -5px;
  vertical-align: middle;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// SurveyView.vue?cb979e6c